import { Flex, Input, Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { CAR_TABS, SEARCH_MAX_LENGTH } from '../../utils/vinExtraction';

const BatchCarsToolbar = ({ counts, tab, onTab, searchText, onSearch }) => {
    const { t } = useTranslation('vinExtraction');
    const options = CAR_TABS.map(({ key, count }) => ({
        value: key,
        label: counts ? `${t(`cars.tabs.${key}`)} ${counts[count]}` : t(`cars.tabs.${key}`),
    }));

    return (
        <Flex justify="space-between" align="center" gap={spacing[2]} wrap="wrap">
            <Segmented aria-label={t('cars.tabsAria')} options={options} value={tab} onChange={onTab} />
            <Input
                allowClear
                value={searchText}
                maxLength={SEARCH_MAX_LENGTH}
                onChange={event => onSearch(event.target.value)}
                placeholder={t('cars.searchPlaceholder')}
                aria-label={t('cars.searchAria')}
                prefix={<i className="fi fi-rr-search" aria-hidden="true" />}
                style={{ maxWidth: 280 }}
            />
        </Flex>
    );
};

export default BatchCarsToolbar;
